import React, { useState } from 'react';
import { Modal } from 'src/components/Modal/Modal';
import { ModalHeader } from 'src/components/Modal/ModalHeader';
import { ModalBody } from 'src/components/Modal/ModalBody';
import { Button } from 'src/components/Button/Button';
import { DeliveryTab } from 'src/components/ProductDetail/DeliveryTab';

import { Svg } from '../Svg/Svg';

import classes from './DeliveryGuideSidebar.scss';

export const DeliveryGuideSidebar: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = () => setIsModalOpen(false);

    return (
        <>
            <Button onClick={() => setIsModalOpen(!isModalOpen)} variant="reset" className={classes.button}>
                <Svg name="delivery_1" />
                Delivery
            </Button>
            <Modal type="sidebar" className={classes.modalContainer} isOpen={isModalOpen} onDismiss={closeModal}>
                <ModalHeader
                    title="Delivery"
                    icon="delivery_1"
                    iconOnRight
                    className={classes.modalHeader}
                    titleClassName={classes.modalHeaderTitle}
                    onDismiss={closeModal}
                />
                <ModalBody>
                    <DeliveryTab className={classes.paragraph} />
                </ModalBody>
            </Modal>
        </>
    );
};

export default DeliveryGuideSidebar;
